<template>
  <FilterPageItem
    :always-open="isEditing"
    :title="title"
    :text="text"
    :link="link"
    :paragraphs="paragraphs"
    :image="image"
    :download-links="downloadLinks"
    :list-style="listStyle"
  >
    <BlokkliField
      :list="paragraphs"
      name="field_paragraphs"
      field-list-type="nested"
    />
  </FilterPageItem>
</template>

<script lang="ts" setup>
import type { ParagraphFilterPageItemFragment } from '#build/graphql-operations'

const { isEditing } = defineBlokkli({
  bundle: 'filter_page_item',
  chunkName: 'rare',
  editor: {
    editTitle: (el) =>
      el.querySelector('summary')?.innerText ||
      el.querySelector('h3')?.innerText,
  },
})

defineProps<{
  title?: ParagraphFilterPageItemFragment['title']
  text?: ParagraphFilterPageItemFragment['text']
  link?: ParagraphFilterPageItemFragment['link']
  paragraphs?: ParagraphFilterPageItemFragment['paragraphs']
  image?: ParagraphFilterPageItemFragment['image']
  downloadLinks?: ParagraphFilterPageItemFragment['downloadLinks']
}>()

defineOptions({
  name: 'ParagraphFilterPageItem',
})

const listStyle = inject<string>('nodeFilterPageStyle', 'list')
</script>
